import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { InputError, InputWrapper, TextInputExtended } from 'src/components';
import { OneFormState } from 'src/types';

interface CodigoPostalProps {
	showProvince?: boolean;
	paddingTop?: string;
	paddingBottom?: string;
	required?: boolean;
}

const getProvinceFromPostalCode = (postalCode: string): string => {
	const code = parseInt(postalCode.substring(0, 2));
	const provinces: { [key: number]: string } = {
		1: 'Álava',
		2: 'Albacete',
		3: 'Alicante',
		4: 'Almería',
		5: 'Ávila',
		6: 'Badajoz',
		7: 'Baleares',
		8: 'Barcelona',
		9: 'Burgos',
		10: 'Cáceres',
		11: 'Cádiz',
		12: 'Castellón',
		13: 'Ciudad Real',
		14: 'Córdoba',
		15: 'A Coruña',
		16: 'Cuenca',
		17: 'Girona',
		18: 'Granada',
		19: 'Guadalajara',
		20: 'Gipuzkoa',
		21: 'Huelva',
		22: 'Huesca',
		23: 'Jaén',
		24: 'León',
		25: 'Lleida',
		26: 'La Rioja',
		27: 'Lugo',
		28: 'Madrid',
		29: 'Málaga',
		30: 'Murcia',
		31: 'Navarra',
		32: 'Ourense',
		33: 'Asturias',
		34: 'Palencia',
		35: 'Las Palmas',
		36: 'Pontevedra',
		37: 'Salamanca',
		38: 'Santa Cruz de Tenerife',
		39: 'Cantabria',
		40: 'Segovia',
		41: 'Sevilla',
		42: 'Soria',
		43: 'Tarragona',
		44: 'Teruel',
		45: 'Toledo',
		46: 'Valencia',
		47: 'Valladolid',
		48: 'Bizkaia',
		49: 'Zamora',
		50: 'Zaragoza',
		51: 'Ceuta',
		52: 'Melilla',
	};
	return provinces[code] || '';
};

export const CodigoPostal = (props: CodigoPostalProps) => {
	const { showProvince, required = true } = props;
	const { register } = useFormContext();
	const { formInfo } = useSelector((state: OneFormState) => state);

	// PostalCode
	const [inputValuePostalCode, setInputValuePostalCode] = useState('');
	const [pristinePostalCode, setPristinePostalCode] = useState(true);
	const [errorPostalCode, setErrorPostalCode] = useState(false);
	const [province, setProvince] = useState('');
	const regExpPostalCode = /\d{5}/gi;
	const dispatch = useDispatch();

	const handleChangePostalCode = (e: any) => {
		dispatch({ type: 'UPDATE_FIELDS', payload: { ['postalCode']: e.target.value } });
		setInputValuePostalCode(e.target.value);
		setPristinePostalCode(false);
	};

	useEffect(() => {
		if (!pristinePostalCode && inputValuePostalCode.match(regExpPostalCode) === null) {
			setErrorPostalCode(true);
		} else {
			setErrorPostalCode(false);
		}

		if (inputValuePostalCode.length === 5 && inputValuePostalCode.match(regExpPostalCode)) {
			setProvince(getProvinceFromPostalCode(inputValuePostalCode));
		} else {
			setProvince('');
		}
	}, [inputValuePostalCode, pristinePostalCode]);

	return (
		<InputWrapper className="codigo_postal-input-wrapper" notALayer={formInfo.notALayer} paddingTop={props.paddingTop} paddingBottom={props.paddingBottom}>
			<TextInputExtended
				name="postalCode"
				label="Código Postal"
				isFloating
				innerRef={register({
					required: {
						value: required,
						message: 'Requerido',
					},
					pattern: {
						value: regExpPostalCode,
						message: 'Solo se aceptan números',
					},
				})}
				onChange={(e) => handleChangePostalCode(e)}
				required={required}
				maxLength={5}
			/>
			{errorPostalCode && <InputError className="input-error">Solo se aceptan números</InputError>}
			{showProvince && <div style={{ position: 'absolute' }}>{province}</div>}
		</InputWrapper>
	);
};
